import { globalContext } from 'context/global';
import { useContextSelector } from 'use-context-selector';

export function useLoadingGlobalStatistics() {
  const loadingStatistics = useContextSelector(
    globalContext,
    context => context.loadingStatistics
  );

  const setLoadingStatistics = useContextSelector(
    globalContext,
    context => context.setLoadingStatistics
  );

  return {
    loadingStatistics,
    setLoadingStatistics,
  };
}
